export const renderTime = (time: number | undefined | null): string => {
    if (time === undefined || time === null) return "Не указано";
  
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
  
    let result = "";
    if (hours > 0) {
      result += `${hours} ч `;
    }
    if (minutes > 0 || hours === 0) {
      result += `${minutes} м`;
    }
  
    return result;
  };